import $ from 'jquery';

const baseClass = 'page-header-slider__disruptors';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class PageHeaderSliderDisruptors {
  constructor(el) {
    this.el = el;
    this.buildDisruptorsMobile();
  }

  buildDisruptorsMobile() {
    let div = $(this.el).clone();
    div.addClass(`${baseClass}-mobile`);
    div.addClass('d-lg-none');
    div.insertBefore($(this.el).closest('.page-header-slider >:first-child'));
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new PageHeaderSliderDisruptors(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
